import React from 'react';
import './informal.css';
import Navbar from '../home_page/navbar';
import Footer from '../home_page/footer';
import InternshipsSection from './informal_plus_internships/informal_plus_internships';

function Informal() {
  return (
    <div className="being-informal-with">
      <Navbar></Navbar>
      <div className="informal-page">
        <InternshipsSection></InternshipsSection>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default Informal;
